module.exports = __webpack_public_path__ + "static/media/educative_logo.474f1ca4.png";